<template>
  <div class="bg-black min-h-screen">
    <LoadingScreen />
    <Toast />
    <router-view></router-view>
  </div>
</template>

<script setup>
import { onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import LoadingScreen from './components/loading-screen.vue';
import Toast from './components/toast.vue';
import { useHead, useSeoMeta } from '@unhead/vue'

// Função para obter o domínio atual dinamicamente
const getCurrentDomain = () => {
  return 'https://portexai.com';
};

const currentDomain = computed(() => getCurrentDomain());

useHead({
  title: 'Portex AI',
  link: [
    { rel: 'canonical', href: currentDomain.value },
  ],
  meta: [
        { property: 'og:title', content: 'Portex AI' },
        { property: 'og:description', content: 'Portex is a full-stack data acquisition and eval platform advancing frontier AI data with better incentives.' },
        { property: 'og:image', content: `${currentDomain.value}/images/og-image.png` },
        { property: 'og:url', content: currentDomain.value },
        { property: 'og:type', content: 'website' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: 'Portex AI' },
        { name: 'twitter:description', content: 'Portex is a full-stack data acquisition and eval platform advancing frontier AI data with better incentives.' },
        { name: 'twitter:image', content: `${currentDomain.value}/images/og-image.png` },
      ],
});

const route = useRoute();

useSeoMeta({
  title: 'Portex AI',
  titleTemplate: route.path === '/' ? '%s' : '%s - Portex AI',
  description: 'Portex is a full-stack data acquisition and eval platform advancing frontier AI data with better incentives.',
  image: `${currentDomain.value}/images/og-image.png`,
  ogUrl: currentDomain.value,
  ogType: 'website',
  twitterCard: 'summary_large_image',
  twitterTitle: 'Portex AI',
  twitterDescription: 'Portex is a full-stack data acquisition and eval platform advancing frontier AI data with better incentives.',
  twitterImage: `${currentDomain.value}/images/og-image.png`,
});

// Ensure dark mode is enabled on app startup
onMounted(() => {
  const htmlElement = document.documentElement;
  if (!htmlElement.classList.contains('dark')) {
    htmlElement.classList.add('dark');
  }
});
</script>

<style lang="scss" scoped>
/* App-specific styles */
</style>